import * as React from "react";

import { useEffect, useState } from "react";

const PencilBoldIcon = ({ className, fill = "#2e2e2e" }) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177531_26195)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3103 6.87844L17.1216 2.68875C16.8402 2.40737 16.4587 2.24929 16.0608 2.24929C15.6629 2.24929 15.2813 2.40737 15 2.68875L3.43969 14.25C3.15711 14.5303 2.99873 14.9123 3 15.3103V19.5C3 20.3284 3.67157 21 4.5 21H8.68969C9.08773 21.0013 9.46966 20.8429 9.75 20.5603L21.3103 9C21.5917 8.71869 21.7498 8.3371 21.7498 7.93922C21.7498 7.54133 21.5917 7.15975 21.3103 6.87844ZM4.81031 15L12.75 7.06031L14.3147 8.625L6.375 16.5637L4.81031 15ZM4.5 16.8103L7.18969 19.5H4.5V16.8103ZM9 19.1897L7.43531 17.625L15.375 9.68531L16.9397 11.25L9 19.1897ZM18 10.1897L13.8103 6L16.0603 3.75L20.25 7.93875L18 10.1897Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_177531_26195">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PencilBoldIcon;
